import React from 'react';
import PropTypes from 'prop-types';

import styles from './errorMessage.scss';

function ErrorMessage(props) {

    const { errors, showAllErrors, isErrorVisible, renderChildren, errorClass, invalidFieldClass } = props;

    const isFieldInvalid = () => {
        return (isErrorVisible && errors && errors.length>0);
    }

    const renderError = (error, index) => {
        return <span className={styles.errorMsg} key={index}>{error}</span>
    }

    const renderErrors = () => {
        if(isErrorVisible && isFieldInvalid()) {
            if(showAllErrors) {
                return errors.map(renderError);
            } else {
                return renderError(errors[0]);
            }
        } else 
            return null;
    }

    return (
        <React.Fragment>
            {renderChildren(isFieldInvalid() ? invalidFieldClass : "")}
            {isFieldInvalid() && <div className={errorClass}>
                {renderErrors()}
            </div>}
        </React.Fragment>
    )
}

ErrorMessage.defaultProps = {
    showAllErrors: false,
    errorClass: styles.errorContainer,
    renderChildren: ()=>{}
}

ErrorMessage.propTypes = {
    errors: PropTypes.array,
    showAllErrors: PropTypes.bool,
    isErrorVisible: PropTypes.bool,
    renderChildren: PropTypes.func,
    errorClass: PropTypes.string,
    invalidFieldClass: PropTypes.string
}

export default ErrorMessage
